import { IAlertConfig } from '../../../models/bootstrap/Alert' 

interface IGatewayScope extends angular.IScope {
    gatewayForm: any
}
export class GatewayModalController {

    alerts: IAlertConfig[] = []
    editMode: boolean;
    $dirty: boolean = false;
    gatewayInfo: any;
        
    static $inject = ['$uibModalInstance', '$scope', 'Gateway', 'gatewayInfo'];
    constructor(private $uibModalInstance, private $scope: IGatewayScope, private Gateway, gatewayInfo) {
        this.gatewayInfo = gatewayInfo;
        gatewayInfo.editMode = gatewayInfo.gatewayCode ? true : false;
    }

    saveGateway() {
        this.$scope.$broadcast('submitted', true);

        var form = this.$scope.gatewayForm;
        this.Gateway.save(this.gatewayInfo)
            .$promise.then(
                () => {
                    form.$setPristine();
                    this.close();
                },
                () => {

                    this.alerts.push({
                        type: 'danger',
                        msg: 'We are sorry but your form could not be saved. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
                        dismissOnTimeout: 5000
                    });
                }
            );
    }

    close() {
        this.$uibModalInstance.close();
    }
}
